module.exports = __webpack_public_path__ + "img/MRT_X_privilege_plus.dc1eebb8.jpg";